(() => {
  const rootSelector = '[data-cbh-product-reviews]';
  const instances = new WeakMap();

  function productData(control) {
    return {
      id: control.dataset.productId || '',
      name: control.dataset.productName || '',
      brand: control.dataset.productBrand || '',
      url: control.dataset.productUrl || '',
      relativeUrl: control.dataset.productRelativeUrl || '',
      format: control.dataset.productFormat || '',
      variantId: control.dataset.productVariantId || '',
      variantName: control.dataset.productVariantName || '',
      sku: control.dataset.productSku || '',
      description: control.dataset.productDescription || '',
      image: control.dataset.productImage || '',
      imageSmall: control.dataset.productImageSmall || '',
      imageAlt: control.dataset.productImageAlt || control.dataset.productName || '',
      price: control.dataset.productPrice || '',
      currency: control.dataset.productCurrency || '',
      available: control.dataset.productAvailable || '',
      gtin: control.dataset.productGtin || ''
    };
  }

  function setAttributeWhenPresent(node, name, value) {
    if (value !== undefined && value !== null && value !== '') node.setAttribute(name, value);
  }

  function applyLipscoreData(node, product, includeDetails = true) {
    setAttributeWhenPresent(node, 'data-ls-product-name', product.name);
    setAttributeWhenPresent(node, 'data-ls-brand', product.brand);
    setAttributeWhenPresent(node, 'data-ls-product-id', product.id);
    setAttributeWhenPresent(node, 'data-ls-product-url', product.url);
    setAttributeWhenPresent(node, 'data-ls-variant-id', product.variantId);
    setAttributeWhenPresent(node, 'data-ls-variant-name', product.variantName);
    setAttributeWhenPresent(node, 'data-ls-sku', product.sku);

    if (!includeDetails) return;

    setAttributeWhenPresent(node, 'data-ls-description', product.description);
    setAttributeWhenPresent(node, 'data-ls-image-url', product.image);
    setAttributeWhenPresent(node, 'data-ls-price', product.price);
    setAttributeWhenPresent(node, 'data-ls-price-currency', product.currency);
    setAttributeWhenPresent(node, 'data-ls-availability', product.available);
    setAttributeWhenPresent(node, 'data-ls-category', product.format);
    setAttributeWhenPresent(node, 'data-ls-gtin', product.gtin);
  }

  function createRating(product) {
    const rating = document.createElement('span');
    rating.className = 'lipscore-rating-small';
    applyLipscoreData(rating, product, true);
    return rating;
  }

  function createReviewCount(product) {
    const count = document.createElement('span');
    count.className = 'lipscore-review-count';
    applyLipscoreData(count, product, false);
    return count;
  }

  function createTestimonial(product) {
    const testimonial = document.createElement('div');
    testimonial.className = 'lipscore-testimonial';
    testimonial.setAttribute('data-cbh-testimonial', '');
    applyLipscoreData(testimonial, product, true);
    return testimonial;
  }

  function createReviewList(product, id, pageSize = 5) {
    const list = document.createElement('div');
    list.className = 'lipscore-review-list';
    list.id = id;
    list.setAttribute('data-cbh-review-list', '');
    list.setAttribute('data-ls-page-size', String(pageSize));
    applyLipscoreData(list, product, true);
    return list;
  }

  function reviewListHasContent(list) {
    if (!list) return false;
    const text = (list.textContent || '').replace(/\s+/g, ' ').trim();
    const meaningfulNode = list.querySelector(
      'article, li, [class*="review-item"], [class*="review_item"], [class*="reviews-list"], [class*="pagination"]'
    );
    return Boolean(meaningfulNode) || text.length > 40;
  }

  function testimonialHasContent(widget) {
    if (!widget) return false;
    const text = (widget.textContent || '').replace(/\s+/g, ' ').trim();
    const meaningfulNode = widget.querySelector(
      'article, blockquote, [class*="testimonial"], [class*="review"], [class*="author"], [class*="customer"]'
    );
    return Boolean(meaningfulNode) || widget.children.length > 0 || text.length > 20;
  }

  function requestLipscoreInitialisation() {
    try {
      if (window.lipscore && typeof window.lipscore.reInitWidgets === 'function') {
        window.lipscore.reInitWidgets(true);
        return true;
      }

      if (window.lipscore && typeof window.lipscore.initWidgets === 'function') {
        window.lipscore.initWidgets();
        return true;
      }

      if (typeof window.lipscoreInit === 'function') {
        window.lipscoreInit();
        return true;
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  function initialise(root) {
    if (!root || instances.has(root)) return;

    const controls = Array.from(root.querySelectorAll('[data-cbh-review-select]'));
    const selectorTrack = root.querySelector('[data-cbh-review-selector]');
    const displayMode = root.dataset.reviewDisplay || 'list';
    const usesTestimonial = displayMode === 'testimonial';
    const reviewPanel = root.querySelector('[data-cbh-review-panel]');
    const reviewShell = root.querySelector('[data-cbh-review-shell]');
    const loading = root.querySelector('[data-cbh-review-loading]');
    const loadingCopy = root.querySelector('[data-cbh-loading-copy]');
    const liveRegion = root.querySelector('[data-cbh-review-live]');
    const reviewProductName = root.querySelector('[data-cbh-review-product-name]');
    const reviewHeadingPrefix = root.querySelector('[data-cbh-review-heading-prefix]');
    const reviewProductLink = root.querySelector('[data-cbh-review-product-link]');
    const reviewIdle = root.querySelector('[data-cbh-review-idle]');
    const reviewSummary = root.querySelector('[data-cbh-review-summary]');
    const testimonialPanel = root.querySelector('[data-cbh-testimonial-panel]');
    const testimonialShell = root.querySelector('[data-cbh-testimonial-shell]');
    const testimonialLoading = root.querySelector('[data-cbh-testimonial-loading]');
    const testimonialLoadingCopy = root.querySelector('[data-cbh-testimonial-loading-copy]');
    const testimonialEmpty = root.querySelector('[data-cbh-testimonial-empty]');
    const spotlight = root.querySelector('[data-cbh-review-spotlight]');
    const spotlightMedia = root.querySelector('[data-cbh-spotlight-media]');
    const spotlightVendor = root.querySelector('[data-cbh-spotlight-vendor]');
    const spotlightFormat = root.querySelector('[data-cbh-spotlight-format]');
    const spotlightTitleLink = root.querySelector('[data-cbh-spotlight-title-link]');
    const spotlightLink = root.querySelector('[data-cbh-spotlight-link]');
    const spotlightRating = root.querySelector('[data-cbh-spotlight-rating]');
    const delayedText = root.dataset.delayedText || 'Reviews are taking a little longer to load. You can also read this product’s feedback on its product page.';
    const reviewPageSize = Math.max(1, Math.min(5, Number.parseInt(root.dataset.reviewPageSize || '5', 10) || 5));
    const rankByReviewCount = root.dataset.rankByReviewCount === 'true';
    const visibleProductLimit = Math.max(1, Number.parseInt(root.dataset.visibleProductLimit || '4', 10) || 4);
    const initialLoadingText = loadingCopy?.textContent || 'Loading published reviews…';
    const initialTestimonialLoadingText = testimonialLoadingCopy?.textContent || 'Loading featured Lipscore review…';
    let reviewList = root.querySelector('[data-cbh-review-list]');
    let testimonial = root.querySelector('[data-cbh-testimonial]');
    let observer = null;
    let delayedTimer = null;
    let retryTimers = [];
    let testimonialObserver = null;
    let testimonialTimer = null;
    let testimonialRetryTimers = [];
    let rankingObserver = null;
    let rankingTimers = [];
    let rankingFinalised = false;
    let rankingInProgress = false;
    let userHasSelected = false;
    let activeControl = controls.find((control) => control.getAttribute('aria-pressed') === 'true') || controls[0] || null;
    const testimonialUnavailable = new Set();
    let generation = 0;

    if (!controls.length) return;
    if (usesTestimonial && (!testimonialPanel || !testimonialShell)) return;
    if (!usesTestimonial && (!reviewPanel || !reviewShell)) return;

    function clearAsyncWork() {
      observer?.disconnect();
      observer = null;
      window.clearTimeout(delayedTimer);
      delayedTimer = null;
      retryTimers.forEach((timer) => window.clearTimeout(timer));
      retryTimers = [];
    }

    function clearTestimonialWork() {
      testimonialObserver?.disconnect();
      testimonialObserver = null;
      window.clearTimeout(testimonialTimer);
      testimonialTimer = null;
      testimonialRetryTimers.forEach((timer) => window.clearTimeout(timer));
      testimonialRetryTimers = [];
    }

    function refreshTestimonialCandidates() {
      if (!usesTestimonial || !selectorTrack) return [];

      const available = controls.filter((control) => !testimonialUnavailable.has(control));
      available.forEach((control, index) => {
        const card = control.closest('.cbh-product-review-showcase__selector-card');
        if (!card) return;
        const hidden = index >= visibleProductLimit;
        card.classList.toggle('is-candidate-overflow', hidden);
        card.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        control.tabIndex = hidden ? -1 : 0;
      });

      return available;
    }

    function nextVisibleTestimonialControl(fromControl) {
      const available = refreshTestimonialCandidates();
      if (!available.length) return null;

      const visible = available.filter((control, index) => index < visibleProductLimit);
      if (!visible.length) return null;

      const currentIndex = visible.indexOf(fromControl);
      if (currentIndex >= 0 && visible[currentIndex + 1]) return visible[currentIndex + 1];
      return visible.find((control) => control !== fromControl) || visible[0];
    }

    function excludeUnavailableTestimonial(control, currentGeneration) {
      if (!usesTestimonial || !control || currentGeneration !== generation) return false;

      testimonialUnavailable.add(control);
      const card = control.closest('.cbh-product-review-showcase__selector-card');
      card?.classList.remove('is-active');
      card?.classList.add('is-testimonial-unavailable', 'is-candidate-overflow');
      card?.setAttribute('aria-hidden', 'true');
      control.setAttribute('aria-pressed', 'false');
      control.tabIndex = -1;

      const replacement = nextVisibleTestimonialControl(control);
      if (!replacement) return false;

      if (liveRegion) {
        liveRegion.textContent = `That product does not currently have a featured customer review. Loading another reviewed product.`;
      }
      selectProduct(replacement, false);
      return true;
    }

    function markTestimonialReady(currentGeneration) {
      if (currentGeneration !== generation || !testimonialPanel) return;
      testimonialPanel.dataset.testimonialState = 'ready';
      if (activeControl) {
        testimonialUnavailable.delete(activeControl);
        activeControl.closest('.cbh-product-review-showcase__selector-card')?.classList.add('has-testimonial');
      }
      if (testimonialEmpty) testimonialEmpty.hidden = true;
      if (liveRegion) {
        const productName = testimonial?.dataset.lsProductName || 'the selected product';
        liveRegion.textContent = `Featured customer review for ${productName} is ready.`;
      }
      window.clearTimeout(testimonialTimer);
      testimonialTimer = null;
      testimonialObserver?.disconnect();
      testimonialObserver = null;
    }

    function markTestimonialEmpty(currentGeneration) {
      if (currentGeneration !== generation || !testimonialPanel) return;

      testimonialObserver?.disconnect();
      testimonialObserver = null;

      if (excludeUnavailableTestimonial(activeControl, currentGeneration)) {
        return;
      }

      testimonialPanel.dataset.testimonialState = 'empty';
      if (testimonialEmpty) testimonialEmpty.hidden = false;
      if (testimonialLoadingCopy) testimonialLoadingCopy.textContent = initialTestimonialLoadingText;
      if (liveRegion) {
        liveRegion.textContent = 'No featured customer reviews are currently available from the configured products.';
      }
    }

    function watchTestimonial(widget, currentGeneration) {
      clearTestimonialWork();
      if (!testimonialPanel) return;

      testimonialPanel.dataset.testimonialState = 'loading';
      if (testimonialEmpty) testimonialEmpty.hidden = true;
      if (testimonialLoadingCopy) testimonialLoadingCopy.textContent = initialTestimonialLoadingText;

      const inspect = () => {
        if (currentGeneration === generation && testimonialHasContent(widget)) {
          markTestimonialReady(currentGeneration);
          return true;
        }
        return false;
      };

      testimonialObserver = new MutationObserver(inspect);
      testimonialObserver.observe(widget, { childList: true, subtree: true, characterData: true, attributes: true });

      [80, 650, 1600, 3000].forEach((delay) => {
        testimonialRetryTimers.push(window.setTimeout(() => {
          if (currentGeneration === generation && testimonialPanel.dataset.testimonialState !== 'ready') {
            requestLipscoreInitialisation();
            inspect();
          }
        }, delay));
      });

      testimonialTimer = window.setTimeout(() => {
        if (!inspect()) markTestimonialEmpty(currentGeneration);
      }, 5200);

      inspect();
    }

    function markReady(currentGeneration) {
      if (currentGeneration !== generation) return;
      reviewPanel.dataset.reviewState = 'ready';
      if (liveRegion) {
        const productName = reviewList?.dataset.lsProductName || 'the selected product';
        liveRegion.textContent = `Published reviews for ${productName} are ready.`;
      }
      window.clearTimeout(delayedTimer);
      delayedTimer = null;
      observer?.disconnect();
      observer = null;
    }

    function watchReviewList(list, currentGeneration) {
      clearAsyncWork();
      reviewPanel.dataset.reviewState = 'loading';
      if (loadingCopy) loadingCopy.textContent = initialLoadingText;

      const inspect = () => {
        if (currentGeneration === generation && reviewListHasContent(list)) markReady(currentGeneration);
      };

      observer = new MutationObserver(inspect);
      observer.observe(list, { childList: true, subtree: true, characterData: true, attributes: true });

      delayedTimer = window.setTimeout(() => {
        if (currentGeneration !== generation || reviewListHasContent(list)) {
          inspect();
          return;
        }
        reviewPanel.dataset.reviewState = 'delayed';
        if (loadingCopy) loadingCopy.textContent = delayedText;
      }, 5000);

      [80, 650, 1600, 3200].forEach((delay) => {
        retryTimers.push(window.setTimeout(() => {
          if (currentGeneration === generation && reviewPanel.dataset.reviewState !== 'ready') {
            requestLipscoreInitialisation();
            inspect();
          }
        }, delay));
      });

      inspect();
    }

    function updateSpotlight(product) {
      if (spotlight) spotlight.hidden = false;
      if (reviewSummary) reviewSummary.hidden = true;
      if (spotlightVendor) spotlightVendor.textContent = product.brand;
      if (spotlightFormat) spotlightFormat.textContent = product.format;

      [spotlightTitleLink, spotlightLink, spotlightMedia].forEach((link) => {
        if (link) link.href = product.relativeUrl || product.url;
      });

      if (spotlightTitleLink) spotlightTitleLink.textContent = product.name;

      if (spotlightMedia) {
        let image = spotlightMedia.querySelector('img');
        const placeholder = spotlightMedia.querySelector('[data-cbh-spotlight-placeholder]');

        if (product.image) {
          if (!image) {
            image = document.createElement('img');
            image.loading = 'eager';
            spotlightMedia.replaceChildren(image);
          }
          image.src = product.image;
          image.srcset = product.imageSmall ? `${product.imageSmall} 360w, ${product.image} 960w` : '';
          image.sizes = '(min-width: 990px) 38vw, 88vw';
          image.alt = product.imageAlt;
        } else if (image) {
          image.remove();
        } else if (!placeholder) {
          const fallback = document.createElement('span');
          fallback.className = 'cbh-product-review-showcase__product-placeholder';
          fallback.setAttribute('data-cbh-spotlight-placeholder', '');
          fallback.setAttribute('aria-hidden', 'true');
          fallback.textContent = 'CBD';
          spotlightMedia.replaceChildren(fallback);
        }
      }

      if (spotlightRating) spotlightRating.replaceChildren(createRating(product), createReviewCount(product));
    }

    function revealActiveControl(control, smooth = true) {
      if (!selectorTrack || !window.matchMedia('(max-width: 749px)').matches) return;

      const card = control.closest('.cbh-product-review-showcase__selector-card');
      if (!card) return;

      window.requestAnimationFrame(() => {
        const trackRect = selectorTrack.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const nextLeft = selectorTrack.scrollLeft
          + cardRect.left
          - trackRect.left
          - ((trackRect.width - cardRect.width) / 2);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        selectorTrack.scrollTo({
          left: Math.max(0, nextLeft),
          behavior: smooth && !reducedMotion ? 'smooth' : 'auto'
        });
      });
    }

    function reviewCountData(control) {
      const card = control.closest('.cbh-product-review-showcase__selector-card');
      const widget = card?.querySelector('[data-cbh-review-count-widget], .lipscore-review-count');
      const text = (widget?.textContent || '').replace(/,/g, '').trim();
      const match = text.match(/\d+/);
      return {
        hydrated: text.length > 0,
        count: match ? Number.parseInt(match[0], 10) : 0,
        card
      };
    }

    function rankHomepageCandidates(force = false) {
      if (!rankByReviewCount || rankingFinalised || rankingInProgress || !selectorTrack || controls.length < 2) return false;

      const ranked = controls.map((control, index) => ({
        control,
        index,
        ...reviewCountData(control)
      }));
      const hydratedCount = ranked.filter((item) => item.hydrated).length;

      if (!force && hydratedCount < ranked.length) return false;
      if (force && hydratedCount === 0) {
        ranked.forEach((item, index) => {
          const hidden = index >= visibleProductLimit;
          item.card?.classList.toggle('is-candidate-overflow', hidden);
          if (item.card) item.card.setAttribute('aria-hidden', hidden ? 'true' : 'false');
          item.control.tabIndex = hidden ? -1 : 0;
        });
        rankingFinalised = true;
        rankingObserver?.disconnect();
        rankingObserver = null;
        return false;
      }

      ranked.sort((a, b) => {
        const aCount = a.hydrated ? a.count : -1;
        const bCount = b.hydrated ? b.count : -1;
        return bCount - aCount || a.index - b.index;
      });

      rankingInProgress = true;
      ranked.forEach((item, index) => {
        if (!item.card) return;
        const hidden = index >= visibleProductLimit;
        item.card.classList.toggle('is-candidate-overflow', hidden);
        item.card.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        item.control.tabIndex = hidden ? -1 : 0;
        selectorTrack.append(item.card);
      });
      rankingInProgress = false;

      const best = ranked.find((item) => item.hydrated && item.count > 0);
      const activeControl = controls.find((control) => control.getAttribute('aria-pressed') === 'true');
      if (best && !userHasSelected && best.control !== activeControl) selectProduct(best.control, false);

      rankingFinalised = true;
      rankingObserver?.disconnect();
      rankingObserver = null;
      rankingTimers.forEach((timer) => window.clearTimeout(timer));
      rankingTimers = [];
      return true;
    }

    function initialiseReviewCountRanking() {
      if (!rankByReviewCount || !selectorTrack || controls.length < 2) return;

      rankingObserver = new MutationObserver(() => {
        if (!rankingInProgress) rankHomepageCandidates(false);
      });
      rankingObserver.observe(selectorTrack, { childList: true, subtree: true, characterData: true });

      [700, 1600, 3000].forEach((delay) => {
        rankingTimers.push(window.setTimeout(() => {
          requestLipscoreInitialisation();
          rankHomepageCandidates(false);
        }, delay));
      });
      rankingTimers.push(window.setTimeout(() => rankHomepageCandidates(true), 5200));
    }

    function selectProduct(control, announce = true) {
      if (!control || testimonialUnavailable.has(control)) return;
      activeControl = control;
      const product = productData(control);
      generation += 1;
      const currentGeneration = generation;
      const listId = reviewList?.id || reviewShell?.dataset.reviewListId || `lipscore-review-list-${Date.now()}`;

      controls.forEach((item) => {
        const card = item.closest('.cbh-product-review-showcase__selector-card');
        const isActive = item === control;
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        card?.classList.toggle('is-active', isActive);
      });

      revealActiveControl(control, announce);

      updateSpotlight(product);
      if (reviewHeadingPrefix) reviewHeadingPrefix.hidden = false;
      if (reviewProductName) reviewProductName.textContent = product.name;
      if (reviewProductLink) {
        reviewProductLink.href = product.relativeUrl || product.url;
        reviewProductLink.hidden = false;
      }
      reviewIdle?.remove();

      if (usesTestimonial) {
        if (announce && liveRegion) liveRegion.textContent = `Loading featured customer review for ${product.name}.`;
        const nextTestimonial = createTestimonial(product);
        if (testimonial) {
          testimonial.replaceWith(nextTestimonial);
        } else {
          testimonialShell.append(nextTestimonial);
        }
        testimonial = nextTestimonial;
        watchTestimonial(testimonial, currentGeneration);
      } else {
        if (announce && liveRegion) liveRegion.textContent = `Loading published reviews for ${product.name}.`;
        const nextList = createReviewList(product, listId, reviewPageSize);
        if (reviewList) {
          reviewList.replaceWith(nextList);
        } else {
          reviewShell.append(nextList);
        }
        reviewList = nextList;
        watchReviewList(reviewList, currentGeneration);
      }
    }

    const listeners = controls.map((control) => {
      const handler = () => {
        if (testimonialUnavailable.has(control)) return;
        userHasSelected = true;
        if (!rankingFinalised) {
          rankingFinalised = true;
          rankingObserver?.disconnect();
          rankingObserver = null;
          rankingTimers.forEach((timer) => window.clearTimeout(timer));
          rankingTimers = [];
        }
        selectProduct(control, true);
      };
      control.addEventListener('click', handler);
      return { control, handler };
    });

    if (usesTestimonial) {
      refreshTestimonialCandidates();
      if (testimonial) {
        generation += 1;
        watchTestimonial(testimonial, generation);
      } else if (testimonialPanel) {
        testimonialPanel.dataset.testimonialState = 'empty';
        if (testimonialEmpty) testimonialEmpty.hidden = false;
      }
    } else if (reviewList) {
      generation += 1;
      watchReviewList(reviewList, generation);
    } else if (reviewPanel) {
      reviewPanel.dataset.reviewState = 'idle';
    }

    initialiseReviewCountRanking();

    instances.set(root, {
      destroy() {
        clearAsyncWork();
        clearTestimonialWork();
        rankingObserver?.disconnect();
        rankingObserver = null;
        rankingTimers.forEach((timer) => window.clearTimeout(timer));
        rankingTimers = [];
        listeners.forEach(({ control, handler }) => control.removeEventListener('click', handler));
        instances.delete(root);
      }
    });
  }

  function boot(scope = document) {
    if (scope.matches?.(rootSelector)) initialise(scope);
    scope.querySelectorAll?.(rootSelector).forEach(initialise);
  }

  function destroy(scope) {
    const roots = [];
    if (scope.matches?.(rootSelector)) roots.push(scope);
    scope.querySelectorAll?.(rootSelector).forEach((root) => roots.push(root));
    roots.forEach((root) => instances.get(root)?.destroy());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
